import { render, staticRenderFns } from "./ObjectNavigator.vue?vue&type=template&id=71289b85&scoped=true"
import script from "./ObjectNavigator.vue?vue&type=script&lang=ts"
export * from "./ObjectNavigator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71289b85",
  null
  
)

export default component.exports